import saveBlobAsFile from 'forms-utils-lib/urls/app/saveBlobAsFile';
import http from 'hub-http/clients/apiClient';
const getInvalidRecipients = () => http.get('forms/app/v1/notifications/invalid-recipients', {
  responseType: 'blob'
}).then(response => saveBlobAsFile(response, 'forms_non_hubspot_user_email_notifications_recipients'));
export default getInvalidRecipients;